import { createCrudApi } from '@core/api/createCrudApi';
import type {
  CreateCustomerData as CoreCreateCustomerData,
  Customer as CoreCustomer,
} from '@core/api/customer';
import type { CustomerTitle } from '@core/enum/customerTitle';
import axiosInstance from '@core/utils/axiosInstance';
import { Diocese } from './diocese';

export interface Customer extends CoreCustomer {
  title?: CustomerTitle | null;
  diocese?: Diocese | null;
  length?: number | null;
  shoulder?: number | null;
  sleeve?: number | null;
  neck?: number | null;
  chest?: number | null;
  waist?: number | null;
  figure?: number | null;
  head?: number | null;
  chasubleLength?: number | null;
  chasubleSleeve?: number | null;
}

export interface CreateCustomerData extends CoreCreateCustomerData {
  title?: CustomerTitle;
  diocese?: number;
  length?: number;
  shoulder?: number;
  sleeve?: number;
  neck?: number;
  chest?: number;
  waist?: number;
  figure?: number;
  head?: number;
  chasubleLength?: number;
  chasubleSleeve?: number;
}

export type UpdateCustomerData = Partial<CreateCustomerData>;

const customerApi = createCrudApi<
  Customer,
  CreateCustomerData,
  UpdateCustomerData
>('customer');

export const getAllCustomers = customerApi.getAll;
export const getCustomerById = customerApi.getById;
export const createCustomer = customerApi.create;
export const updateCustomer = customerApi.update;
export const deleteCustomer = customerApi.delete;

export interface CustomerQuery {
  search?: string;
  diocese?: string;
}

export interface CustomerPageParams extends CustomerQuery {
  offset: number;
  limit: number;
}

export interface CustomerPage {
  items: Customer[];
  total: number;
  offset: number;
  limit: number;
}

export const customerKeys = {
  all: ['customers'] as const,
  pages: ['customers', 'page'] as const,
  page: (query?: CustomerQuery) => ['customers', 'page', query] as const,
  byId: (id: number) => ['customers', 'byId', id] as const,
};

export async function getCustomersPage(
  params: CustomerPageParams
): Promise<CustomerPage> {
  const { data } = await axiosInstance.get<CustomerPage>('/customer/page', {
    params,
  });
  return data;
}
